/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import useId from '../private/hooks/useId';
import { FormController } from '../form/FormController';
import { FormLabel } from '../form/FormLabel';
import { FormHelpMessage } from '../form/FormHelpMessage';
import { FormStatusMessage } from '../form/FormStatusMessage';
import { Dropdown } from './Dropdown';

const DropdownField = (props) => {
  const {
    label,
    labelProps,
    dropdownProps,
    disabled,
    status,
    children,
    helpMessage,
    fullWidth,
    statusMessage,
    value,
    defaultValue,
    id: idProp
  } = props;

  const id = useId(idProp);
  const formLabelId = label && id ? `${id}-label` : undefined;
  const helpMessageId = helpMessage && id ? `${id}-help-message` : undefined;
  const statusMessageId = statusMessage && id ? `${id}-status-message` : undefined;
  const ariaDescribedby = [];
  if (statusMessageId) ariaDescribedby.push(statusMessageId);
  if (helpMessageId) ariaDescribedby.push(helpMessageId);

  return (
    <FormController disabled={disabled} status={status} fullWidth={fullWidth}>
      <FormLabel
        htmlFor={id}
        id={formLabelId}
        {...labelProps}
      >
        {label}
      </FormLabel>
      <Dropdown
        aria-describedby={ariaDescribedby.length ? ariaDescribedby.join(' ') : undefined}
        disabled={disabled}
        id={id}
        value={value}
        defaultValue={defaultValue}
        {...dropdownProps}
      >
        {children}
      </Dropdown>
      {statusMessage && (
        <FormStatusMessage id={statusMessageId}>
          {statusMessage}
        </FormStatusMessage>
      )}
      {helpMessage && (
        <FormHelpMessage id={helpMessageId}>
          {helpMessage}
        </FormHelpMessage>
      )}
    </FormController>
  );
};

DropdownField.displayName = 'DropdownField';

DropdownField.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  status: PropTypes.oneOf(['error', 'success', 'warning']),
  /**
   * The description for the TextField component.
   */
  helpMessage: PropTypes.string,
  /**
   * Adds a message when there is a status value.
   */
  statusMessage: PropTypes.string,
  /**
   * The prop values that will be added to the FormLabel component.
   */
  labelProps: PropTypes.object,
  /**
   * The prop values that will be added to the Dropdown component.
   */
  dropdownProps: PropTypes.object,
  /**
   * The value of the selected menu item.
   * Dropdown is considered controlled if, on initial render, value is not `undefined`.
   */
  value: PropTypes.node,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any
};

export { DropdownField };